import React, { useState, useEffect } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { geraStringAleatoria } from "../../utils/geraStringAleatoria";

const useStyles = makeStyles((theme) => ({
  dialogTitle: { background: "#0f766e", color: "#fff", padding: theme.spacing(2) },
  infoBox: { background: "#ccfbf1", border: "1px solid #99f6e4", borderRadius: 8, padding: theme.spacing(1.5), marginBottom: theme.spacing(2) },
  infoText: { fontSize: "0.82rem", color: "#134e4a", lineHeight: 1.7 },
  handlesBox: { background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 8, padding: theme.spacing(1.5), marginTop: theme.spacing(1.5) },
}));

const FlowBuilderSgpDiagnosticoModal = ({ open, onSave, data, onUpdate, close }) => {
  const classes = useStyles();

  useEffect(() => {
    if (open === "edit" && data?.data?.data) {
      // sem configurações extras por enquanto
    }
  }, [open, data]);

  const handleSave = () => {
    if (open === "edit") {
      onUpdate(data.id, { data: { label: "Diagnóstico de Conexão SGP", data: {} } });
    } else {
      onSave({ label: "Diagnóstico de Conexão SGP", data: {}, id: geraStringAleatoria(30) });
    }
    close();
  };

  return (
    <Dialog open={!!open} onClose={close} fullWidth maxWidth="sm" scroll="paper">
      <DialogTitle className={classes.dialogTitle}>SGP — Diagnóstico de Conexão</DialogTitle>
      <DialogContent>
        <Box className={classes.infoBox}>
          <Typography className={classes.infoText}>
            Fluxo autônomo de suporte técnico para problemas de internet.<br /><br />
            <strong>O que o nó faz automaticamente:</strong><br />
            1. Solicita o CPF do cliente<br />
            2. Verifica se há manutenção ativa na área (campo <em>motivo_status</em> do contrato)<br />
            3. Verifica chamados de internet já abertos (evita duplicatas)<br />
            4. Inicia checklist guiado:<br />
            &nbsp;&nbsp;• A luz Power/ONU está acesa?<br />
            &nbsp;&nbsp;• A luz de Internet/WAN está acesa?<br />
            &nbsp;&nbsp;• Já tentou reiniciar o aparelho?<br />
            5. Se não reiniciou: orienta reinício e aguarda resposta<br />
            6. Se o problema persistir: abre chamado automaticamente com todas as respostas do checklist
          </Typography>
        </Box>

        <Box className={classes.handlesBox}>
          <Typography style={{ fontSize: "0.8rem", color: "#166534", fontWeight: 600, marginBottom: 6 }}>
            Saídas disponíveis
          </Typography>
          {[
            { color: "#f59e0b", handle: "manutencao",        desc: "Manutenção detectada na área do cliente" },
            { color: "#3b82f6", handle: "chamado_existente",  desc: "Já existe OS de internet aberta para o contrato" },
            { color: "#22c55e", handle: "chamado_aberto",     desc: "Novo chamado aberto com protocolo gerado" },
            { color: "#8b5cf6", handle: "resolvido",          desc: "Cliente confirmou que a internet voltou após reinício" },
            { color: "#ef4444", handle: "erro",               desc: "Erro na consulta ao SGP ou cliente não encontrado" },
          ].map(h => (
            <div key={h.handle} style={{ display: "flex", alignItems: "flex-start", marginBottom: 4 }}>
              <span style={{ width: 10, height: 10, borderRadius: "50%", background: h.color, flexShrink: 0, marginTop: 3, marginRight: 8 }} />
              <Typography style={{ fontSize: "0.78rem", color: "#374151" }}>
                <strong>{h.handle}</strong> — {h.desc}
              </Typography>
            </div>
          ))}
        </Box>

        <Box style={{ marginTop: 12, padding: 10, background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 8 }}>
          <Typography style={{ fontSize: "0.78rem", color: "#92400e" }}>
            ℹ️ A variável <strong>{"{{sgp_protocolo}}"}</strong> fica disponível após abertura do chamado.
            O nó não precisa de configuração adicional — usa as credenciais SGP cadastradas nas Integrações.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="secondary">Cancelar</Button>
        <Button onClick={handleSave} color="primary" variant="contained">Salvar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderSgpDiagnosticoModal;
